/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

export interface MediaQueryBuilderLogic {
  query: string;
  and: MediaQueryBuilderLiterals;
  or: MediaQueryBuilderLiterals;
}

export interface MediaQueryBuilderLiterals {
  landscape: MediaQueryBuilderLogic;
  portrait: MediaQueryBuilderLogic;

  gt(pixels: number): MediaQueryBuilderLogic;

  ge(pixels: number): MediaQueryBuilderLogic;

  lt(pixels: number): MediaQueryBuilderLogic;

  le(pixels: number): MediaQueryBuilderLogic;

  expression(expression: string): MediaQueryBuilderLogic;
}

export class MediaQueryBuilder
  implements MediaQueryBuilderLogic, MediaQueryBuilderLiterals
{
  static readonly MARGIN = 0.1;

  private _query = "";

  static is(): MediaQueryBuilderLiterals {
    return new MediaQueryBuilder();
  }

  /*region Operators & Logic*/
  get query(): string {
    return this._query;
  }

  get and(): MediaQueryBuilderLiterals {
    this._query += " and ";
    return this;
  }

  get or(): MediaQueryBuilderLiterals {
    this._query += " or ";
    return this;
  }

  get landscape(): MediaQueryBuilderLogic {
    return this.expression("orientation: landscape");
  }

  get portrait(): MediaQueryBuilderLogic {
    return this.expression("orientation: portrait");
  }

  gt(pixels: number): MediaQueryBuilderLogic {
    return this.expression(
      "min-width: " + (pixels + MediaQueryBuilder.MARGIN) + "px"
    );
  }

  ge(pixels: number): MediaQueryBuilderLogic {
    return this.expression("min-width: " + pixels + "px");
  }

  lt(pixels: number): MediaQueryBuilderLogic {
    return this.expression(
      "max-width: " + (pixels - MediaQueryBuilder.MARGIN) + "px"
    );
  }

  le(pixels: number): MediaQueryBuilderLogic {
    return this.expression("max-width: " + pixels + "px");
  }

  expression(expression: string): MediaQueryBuilderLogic {
    this._query += "(" + expression + ")";
    return this;
  }
}

export const BREAKPOINTS = {
  XXS: 320,
  XS: 480,
  S: 768,
  M: 992,
  L: 1280,
  XL: 1600,
  XXL: 1920
};

export const MARGINS = {
  XXS: 14,
  XS: 14,
  S: 14,
  M: 16,
  L: 32,
  XL: 32,
  XXL: 32
};

const mobilePortrait = MediaQueryBuilder.is().lt(BREAKPOINTS.S).and.portrait
  .query;

const tabletPortrait = MediaQueryBuilder.is()
  .ge(BREAKPOINTS.S)
  .and.lt(BREAKPOINTS.M).and.portrait.query;

const desktopPortrait = MediaQueryBuilder.is().ge(BREAKPOINTS.M).and.portrait
  .query;

const mobileLandscape = MediaQueryBuilder.is().lt(BREAKPOINTS.M).and.landscape
  .query;

const tabletLandscape = MediaQueryBuilder.is()
  .ge(BREAKPOINTS.M)
  .and.lt(BREAKPOINTS.L).and.landscape.query;

const desktopLandscape = MediaQueryBuilder.is().ge(BREAKPOINTS.L).and.landscape
  .query;

export const MEDIA_QUERIES = {
  mobile: `${mobilePortrait}, ${mobileLandscape}`,
  tablet: `${tabletPortrait}, ${tabletLandscape}`,
  desktop: `${desktopPortrait}, ${desktopLandscape}`,
  mobilePortrait: mobilePortrait,
  tabletPortrait: tabletPortrait,
  desktopPortrait: desktopPortrait,
  mobileLandscape: mobileLandscape,
  tabletLandscape: tabletLandscape,
  desktopLandscape: desktopLandscape
};

export const FLEX_BREAKPOINTS = [
  {
    alias: "mobile",
    suffix: "mobile",
    mediaQuery: `${mobilePortrait}, ${mobileLandscape}`,
    overlapping: false
  },
  {
    alias: "tablet",
    suffix: "tablet",
    mediaQuery: `${tabletPortrait}, ${tabletLandscape}`,
    overlapping: false
  },
  {
    alias: "desktop",
    suffix: "desktop",
    mediaQuery: `${desktopPortrait}, ${desktopLandscape}`,
    overlapping: false
  }
];
